import { createSlice, createAction } from '@reduxjs/toolkit';
import { convertToBuilderNotation } from '../../utils';

export const billingAddressOptions = {
  same: 'same-as-shipping',
  different: 'different-as-shipping',
};

const billingAddressInitialState = {
  email: '',
  phone: '',
  firstName: '',
  lastName: '',
  streetAddress: '',
  additionalStreetInfo: '',
  postalCode: '',
  city: '',
  country: 'US',
  state: '',
};

export const setBillingAddressOption = createAction(
  'billingAddress/setBillingAddressOption',
);
export const setBillingAddressDraft = createAction(
  'billingAddress/setBillingAddressDraft',
);
export const setIsValidate = createAction('billingAddress/setIsValidate');
export const setIsValid = createAction('billingAddress/setIsValid');

export const billingAddressSlice = createSlice({
  name: 'billingAddress',
  initialState: {
    billingAddressOption: billingAddressOptions.same,
    billingAddressDraft: billingAddressInitialState,
    isValidate: false,
    isValid: false,
  },
  reducers: {
    setBillingAddressOption: (state, action) => {
      const billingAddressDraft =
        action.payload === billingAddressOptions.same
          ? state.billingAddressDraft
          : {
              ...billingAddressInitialState,
              email: state.billingAddressDraft.email,
              phone: state.billingAddressDraft.phone,
            };
      return {
        ...state,
        billingAddressDraft,
        billingAddressOption: action.payload,
      };
    },
    setBillingAddressDraft: (state, action) => ({
      ...state,
      billingAddressDraft: action.payload,
    }),
    setIsValidate: (state, action) => ({
      ...state,
      isValidate: action.payload,
    }),
    setIsValid: (state, action) => ({
      ...state,
      isValid: action.payload,
    }),
  },
  extraReducers: convertToBuilderNotation({}),
});

export default billingAddressSlice.reducer;
